import makeService from './api';

export default makeService('profile_parameter_sets');
